export default __webpack_public_path__ + "static/media/freck-masterImage.5c3d4af2.png";